import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import Editor from "@monaco-editor/react";

interface JsonEditorProps {
  value: string;
  onChange: (newValue: string) => void;
  editable?: boolean; 
}

const JsonEditor: React.FC<JsonEditorProps> = ({ value, onChange ,editable}) => {
  const handleEditorChange = (newValue?: string) => {
    onChange(newValue || ""); // Ensure empty string if undefined
  };

  return (
    <Box
    sx={{
      border: "1px solid #7e839280", // Change color as needed
      borderRadius: "5px",
      overflow: "hidden", // Ensures rounded corners apply correctly
    }}
  >
        <Editor
          height="20vh"
          defaultLanguage="json"
          value={value}
          onChange={handleEditorChange}
          options={{
            readOnly: !editable,
            minimap: { enabled: false },
            formatOnPaste: true,
            padding: { top: 10,bottom:10},
            lineNumbers: "off", // Disable line numbers
          }}
        />
        </Box>
  );
};

export default JsonEditor;
